package com.bikompanion.data.parking

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import com.bikompanion.data.cache.LocalStore
import com.bikompanion.data.cache.cacheKey
import com.bikompanion.domain.ParkingCountdownRepository
import com.bikompanion.domain.di.AppScope

private const val DeadlineKey = "bicing_parking_deadline"

/**
 * Persists the deadline as a bare epoch-millis string.
 *
 * A single primitive needs none of the JSON envelope [com.bikompanion.data.rating.PendingVoteQueue]
 * uses for its list — there's exactly one value, and `toString`/`toLongOrNull` round-trip it
 * without help. An unset deadline and a corrupt one both read back as null, which is the same
 * "nothing is running" a caller would do with either.
 */
@ContributesBinding(AppScope::class)
@Inject
class ParkingCountdownRepositoryImpl(
    private val store: LocalStore,
) : ParkingCountdownRepository {
    override fun getDeadline(): Long? = store.read(cacheKey(DeadlineKey))?.toLongOrNull()

    override fun setDeadline(epochMillis: Long?) {
        store.write(cacheKey(DeadlineKey), epochMillis?.toString().orEmpty())
    }
}
